__turbopack_context__.v({
  "error": "UploadImageQR-module-scss-module__GdbL_G__error",
  "intro-text-phone": "UploadImageQR-module-scss-module__GdbL_G__intro-text-phone",
  "scan-info-text": "UploadImageQR-module-scss-module__GdbL_G__scan-info-text",
  "upload-button-label": "UploadImageQR-module-scss-module__GdbL_G__upload-button-label",
  "upload-input": "UploadImageQR-module-scss-module__GdbL_G__upload-input",
  "upload-qr": "UploadImageQR-module-scss-module__GdbL_G__upload-qr",
  "upload-qr-wrapper": "UploadImageQR-module-scss-module__GdbL_G__upload-qr-wrapper",
});
